import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Alias legado → Contas unificadas (aba pagar). */
const ContasAPagar: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/financeiro/contas?tab=pagar', { replace: true });
  }, [navigate]);
  return null;
};

export default ContasAPagar;
